import cn from "classnames";
import styles from "./Loader.module.scss";

type LoaderProps = {
  size?: string;
  className?: string;
};

export const Loader: RFC<LoaderProps> = ({ size = "32px", className }) => {
  const loaderStyle = {
    width: size,
    height: size,
  };

  return <div className={cn(styles.loader, className)} style={loaderStyle}></div>;
};
